import { ProductCollectionsApi } from '@psl/generated/api';
import configuration from './configuration';

export default new ProductCollectionsApi(configuration);
